import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
/**
 * @export BaseModel
 * @class BaseModel
 * @desc model 的基类，用来继承
 * @author lei.you
 * @date 2018/2/8
 * */
class BaseModel {

  constructor(config = {}) {
    // 请求拦截处理队列
    this.requestInterceptorsQueue = [];
    // 响应拦截处理队列
    this.responseInterceptorsQueue = [];
    let {CancelToken} = axios;

    let cancel ;

    config.cancelToke = new CancelToken(((c) => {
      cancel = c;
    }));
    //config.baseURL=config.baseURL|| envInfo.baseUrl;
    config.timeout = config.timeout || 5000;
    let xhttpInstance = axios.create(config);

    this.xhttpInstance = xhttpInstance;
    // 拦截请求
    this.interceptorsRequestFun = this.xhttpInstance.interceptors.request;
    // 拦截返回
    this.interceptorsResponseFun = this.xhttpInstance.interceptors.response;
    this.cancel = cancel;
    this.config = config;
    this.modelList = [];
    this._interceptorsRequest();
    this._interceptorsResponse();
  }

  /**
   * @description 为了最大限度减少底层对业务的强耦合，我们把强求拦截做成一个方法队列在继承BaseModel 后可以单个class 中，往请求拦截处理队列添加处理方法
   * @params {function||array}
   *
   * */
  setRequestInterceptorsQueue(fun) {
    if (_.isFunction(fun)) {
      this.requestInterceptorsQueue.push(fun);
    } else if (Array.isArray(fun)) {
      for (let f of fun) {
        if (_.isFunction(f)) {
          this.requestInterceptorsQueue.push(f);
        } else {
          throw ('element of array type is need Function');
        }
      }
    }

  }

  /**
   * @description 往请求拦截处理队列添加处理方法
   * @params {function||array}
   *
   * */
  setResponseInterceptorsQueue(fun) {
    if (_.isFunction(fun)) {
      this.responseInterceptorsQueue.push(fun);
    } else if (Array.isArray(fun)) {
      for (let f of fun) {
        if (_.isFunction(f)) {
          this.responseInterceptorsQueue.push(f);
        } else {
          throw ('element of array type is need Function');
        }
      }
    }
  }

  /**
   *  @description request拦截器默认逻辑，
   * */
  _interceptorsRequest() {
    this.interceptorsRequestFun.use(config=>{
      /**

       */
      if (config.method === 'post') {
        config.data = config.data || {};
        for(let h in config.headers){
          if(h.toLocaleLowerCase()==="content-type"&&config.headers[h]==="application/x-www-form-urlencoded"){
            config.data = qs.stringify(config.data || {});
          }
        }
         

      }
      for (let fn of this.requestInterceptorsQueue) {
        fn(config);
      }

      return config;
    }, error=>Promise.reject(error.message));

  }

  /**
   *  @description response拦截器默认逻辑，可以被子类覆盖
   * */
  _interceptorsResponse() {
    this.interceptorsResponseFun.use((res) => {
      //supreme.indicator.close();
      for (let fn of this.responseInterceptorsQueue) {
        fn(res);
      }
      return res;
    }, (error) =>
      //supreme.indicator.close();
      Promise.reject(error.message));
  }

  /**
   * @description 框架中结合业务建议使用的请求方式
   * @param param 默认参数，主要是请求参数数据放在http body 中
   * @param config 和请求配置相关header 设置等等非body数据
   * */
  post(param, config = {}) {
    /**
     *  扩展config 参数
     * */
    //supreme.$.extend(config,this.config);
    // 对请求进行并发处理
    if (this.modelList.length > 0) {
      this.xhttpInstance.all();
    } 
    _.extend(config, this.config);

    return this.xhttpInstance.post(this.config.url, param, config);
  }

  get(param, config = {}) {
    let data = {
      params:param.params ? param.params : param,
      ...config
    };

    return this.xhttpInstance.get(this.config.url || this.config.baseURL, data);
  }

  delete(param, config = {}) {
    _.extend(config, this.config);
    return this.xhttpInstance.delete(this.config.url, param, config);
  }

  head(param, config = {}) {
    _.extend(config, this.config);
    return this.xhttpInstance.head(this.config.url, param, config);
  }

  patch(param, config = {}) {
    _.extend(config, this.config);
    return this.xhttpInstance.patch(this.config.url, param, config);
  }

  put(param, config = {}) {
    _.extend(config, this.config);
    return this.xhttpInstance.put(this.config.url, param, config);
  }



  exec(param) {
    return this.post(param);
  }

  /**
   * @desc 执行数据请求 框架中默认统一使用post 方式请求数据
   * @param {object}  参数
   *
   * */
  execute(param) {
    return this.exec(param);
  }
  /***
   *
   * @description 取消promise 请求
   *
   * */

  cancel() {
    //this.cancel();
  }

  /**
   * @desc 生成baseModel 实例
   * @param {object} config 配置文件
   * @return {baseModel} baseModel 实例
   * */
  static getInstance(config) {
    let model = new BaseModel(config);

    model.config = config;
    return model;
  }
}
//supreme.BaseModel = BaseModel;
export default BaseModel;
//module.exports = BaseModel;
